import * as React from 'react'
import * as PropTypes from 'prop-types'
import styled from 'styled-components'
import { Fade } from 'react-reveal'

const Card = styled.div`
  position: relative;
  background: #ffffff;
  border: 1px solid #ebebeb;
  border-radius: 10px;
  padding: 1.25rem 1.125rem;
  width: 100%;
  overflow: hidden;
  margin-top: 1rem;
  font-size: 12px;
  cursor: pointer;
`

const Header = styled.div`
  font-size: 16px;
  font-weight: var(--font-weight-bold);
  color: var(--color-fg-dark);
  margin-bottom: 5px;
`

const Text = styled.span`
  transition: all var(--animation-duration) var(--animation-easing);
`

function VerifyEmailCard(props) {
  const {
    email,
    onVerifyClick,
    verifyState,
    sendingVerify,
    ...restProps
  } = props

  return (
    <Fade duration={300}>
      <Card {...restProps} onClick={onVerifyClick}>
        <Header>Verify Email Address</Header>
        <Text>
          {sendingVerify ? (
            <>{verifyState === 0 ? `Sending...` : `Resending...`}</>
          ) : (
            <>
              {(verifyState === 0 || verifyState === 3) &&
                `It seems that you have not verified your email ${email}. Click to verify now`}

              {verifyState === 1 &&
                `Please check the verification link sent to your email ${email}. Click to resend verification link.`}
            </>
          )}
        </Text>
      </Card>
    </Fade>
  )
}

VerifyEmailCard.defaultProps = {
  verifyState: 0,
}

VerifyEmailCard.propTypes = {
  firstName: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  verifyState: PropTypes.oneOf([0, 1]),
}

export default VerifyEmailCard
